"use client";
import React from "react";
import { Input as AntInput } from "antd";
import type { InputProps as AntInputProps } from "antd";
import { FormControl, FormControlProps } from "../FormControl";
import { useDisabled } from "../useDisabled";
import { useAccount, useBalance } from "wagmi";
import { formatEther } from "viem";

export type InputProps = AntInputProps &
  FormControlProps & {
    loading?: boolean;
  } & (
    | { chainId: number; showBalance: true }
    | { chainId?: number; showBalance?: false }
  );

const Balance = ({ chainId }: { chainId: number }) => {
  const { address } = useAccount()
  const balance = useBalance({ chainId, address });
  if(!balance.data){
    return null;
  }
  return (
    // TODO: tailwind
    <span
      style={{
        fontSize: "smaller",
      }}
    >
      Balance: {formatEther(balance.data?.value).slice(0, 5)}{" "}
      {balance.data?.symbol}
    </span>
  );
};

export function Input({
  label,
  description,
  name,
  helpText,
  className,
  error,
  optional,
  loading,
  labelExtra,
  showBalance,
  chainId,
  style,
  ...props
}: InputProps) {
  const ctxDisabled = useDisabled();
  const disabled = props.disabled || ctxDisabled || loading;
  return (
    <FormControl
      label={label}
      name={name}
      disabled={disabled}
      description={description}
      error={error}
      helpText={helpText}
      optional={optional}
      labelExtra={showBalance ? <Balance chainId={chainId} /> : labelExtra}
      className={className}
    >
      <AntInput
        id={name}
        name={name}
        {...props}
        disabled={disabled}
        status={error ? "error" : ""}
        data-1p-ignore
        data-lpignore="true"
      />
    </FormControl>
  );
}
